import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdditionOfManpowerService {

 
  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_SiteManpowerAdditionReduction(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteManpowerAddition/Reduction`,
      this.session.SetClass(Detail)                   
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteManpowerAdditionReductionGet(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteManpowerAdditionReduction/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteManpowerValidation(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteManpowerValidation/Check`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteManpowerSummary(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteManpowerSummary/Details`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `FillComboOnMultiple/Selections`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

}
